import { render, staticRenderFns } from "./CarreraListAddNew.vue?vue&type=template&id=219ee6d0&"
import script from "./CarreraListAddNew.vue?vue&type=script&lang=js&"
export * from "./CarreraListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CarreraListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports